export default {
    headText: '',
    maskBox: false,
    adoptDialog: false,
    failDialog: false,
    failDialogChina: false,
    exitGameMode: false,
    adoptChinaDialog: false,
    adoptTitle: '',
    adoptText: '',
    failTitle: '',
    failText: '',
    ideMask: false,
    isLoading: false,
    imagesLoaded: false,
    loadingText: '',
    welcomeDialog: false,
    codeIndexDialog: false,
    checkpointShow: false, //关卡
    selectedPoint: '', //选中当前关卡
    funArr: [],
    funVisibleArr: [], // 可见的动作列表
    funIndex: 0, // 当前所在的动作列表的索引（点击向左-1， 点击向右+1）
    funShowCount: 0, // 显示的动作列表的个数
    checkpointData: [], //关卡信息
    explainDialog: false, //功能说明弹窗
    explainDialog1: false,
    explainDialog2: false,
    toBack: false,
    menuFlag: false, //菜单节流阀
    knowledgeArr: [], //知识点说明
    CommandList: [], //游戏说明
    StoryIntroList: [],
    CommentImgList: true, //注释图片展示
    imagePath: "",
    sessionShow: false,
    videoShow: false,
    checkLangShow: false,
    skipShow: false,
    currentIndex: false, //当前所在的位置
    highCheckShow: false,
    imgShow: false,
    isLastLevel: false, //判断是否是最后一关
    justLastLevel:false,
    skipStyleShow: true,
    skipNextShow: false,
    browserVersionShow: false,
    highLevelShow: false,
    welcomeDialogShow: false,
    passAllLevelShow: false,
    interfaceErrorShow: false,
    audioShow: false,
    ipShow:false,
    times:0,
    competeType:0,
    edition:0,//0 入门组 1 初级组 3 中级组 2 高级组
    isVip:0,// 0 非vip 1 vip
    timeoverShow:false,
    imgList: [],
    dirLang: 'ltr',
    fullName: "",
    level: '',
    lang: "en",
    allStar: 0,
    configLine: 0,
    configSteps: 0,
    curLine: 0,
    curSteps: 0,
    star: 0,
    userLastName: "",
    userFirstName: "",
    isPassAllLevel: 0,
    currentLevel: "",
    qrCodeUrl: "",
    qrCodeShow: false,
    qrCodeShow2: false,
    codeShow: false,
    chooseMode:"code",
    getQRcode: "",
    blocklyShow:false,
    checkLangDialogShow:false,
    checkLangs:"en",
    blocklyText:{},
    Workspace:{},
    maxHighlevel:'',
    xml_text:'',
    blPython:'',
    gameId:"",
    courseTitleTxt:"",
    timeText:"00:00",
    monthlyGameShow:false,
    loadingTimeShow:true,
    totalScore:0,
    tourCompelete:false,
    tourNotCompelete:false,
    tourCompeleteNotGet:false,
    tourGameNotPass:false,
    pathAllImage:"",
    icode_qq_txt:"遇到问题了?加群求助吧<br />官方QQ群：925210380 <br />你也可以扫码加入哦！",
    allArr: [
        { id: 20, describe: 'step', img: process.env.IMG_BASE_URL + 'mars_step.png', code: '.step()', tips: 'step' },
        { id: 21, describe: 'turnLeft', img: process.env.IMG_BASE_URL + 'mars_turnLeft.png', code: '.turnLeft()', tips: 'turnLeft' },
        { id: 22, describe: 'turnRight', img: process.env.IMG_BASE_URL + 'mars_turnRight.png', code: '.turnRight()', tips: 'turnRight' },
        { id: 25, describe: 'for', img: process.env.IMG_BASE_URL + 'mars_for.png', code: 'for i in range():', tips: 'for' },
        { id: 27, describe: 'distanceTo', img: process.env.IMG_BASE_URL + 'mars_distanceTo.png', code: '.distanceTo()', tips: 'distance' },
        { id: 30, describe: 'while', img: process.env.IMG_BASE_URL + 'mars_while.png', code: 'while', tips: 'while' },
        { id: 31, describe: 'turnTo', img: process.env.IMG_BASE_URL + 'mars_turnTo.png', code: '.turnTo()', tips: 'turnToOb' },
        { id: 32, describe: 'chase', img: process.env.IMG_BASE_URL + 'mars_chase.png', code: '.chase()', tips: 'chase' },
        { id: 33, describe: 'function', img: process.env.IMG_BASE_URL + 'mars_function.png', code: 'def', tips: 'def' },
        { id: 35, describe: 'if', img: process.env.IMG_BASE_URL + 'mars_if.png', code: 'if', tips: 'if' },
        { id: 36, describe: 'if_else', img: process.env.IMG_BASE_URL + 'mars_ifelse.png', code: 'if \n' + '\n' + 'else ', tips: 'if_else' },
        { id: 38, describe: 'wait', img: process.env.IMG_BASE_URL + 'mars_wait.png', code: 'wait()', tips: 'wait' },
        { id: 39, describe: 'for', img: process.env.IMG_BASE_URL + 'mars_for.png', code: 'for en in Energy:', tips: 'for_in' },
        { id: 40, describe: 'onClick', img: process.env.IMG_BASE_URL + 'mars_onClick.png', code: 'onClick()', tips: 'onClick' },
        { id: 41, describe: 'onTouch', img: process.env.IMG_BASE_URL + 'mars_onTouch.png', code: 'onTouch(pos):', tips: 'onTouch' },
        { id: 42, describe: 'mover', img: process.env.IMG_BASE_URL + 'mars_goto.png', code: 'mover.', tips: 'mover' },
        { id: 43, describe: 'power', img: process.env.IMG_BASE_URL + 'mars_health.png', code: '.energy', tips: 'energy' },
        { id: 45, describe: 'broken', img: process.env.IMG_BASE_URL + 'mars_broken.png', code: '.broken()', tips: 'broken' },
        { id: 46, describe: 'goNrsSolar', img: process.env.IMG_BASE_URL + 'mars_goNearesSolar.png', code: 'goNearesSolar( )', tips: 'goNearesSolar' },
        { id: 48, describe: 'return', img: process.env.IMG_BASE_URL + 'mars_return.png', code: 'return', tips: 'return' },
        { id: 50, describe: 'goodH', img: process.env.IMG_BASE_URL + 'mars_goodHealth.png', code: 'goodHealth()', tips: 'goodHealth' },
        { id: 51, describe: 'badH', img: process.env.IMG_BASE_URL + 'mars_badHealth.png', code: 'badHealth()', tips: 'badHealth' },
        { id: 53, describe: 'disappear', img: process.env.IMG_BASE_URL + 'mars_disapper.png', code: '.disappear()', tips: 'disappear' },
        { id: 56, describe: 'clickQiQi', img: process.env.IMG_BASE_URL + 'mars_clickQiQi.png', code: 'clickQiQi()', tips: 'clickQiQi' },
        { id: 57, describe: 'clickAirship', img: process.env.IMG_BASE_URL + 'mars_clickAirship.png', code: 'clickAirship()', tips: 'clickAirship' },
        { id: 58, describe: 'clickEnergy', img: process.env.IMG_BASE_URL + 'mars_clickEnergy.png', code: 'clickEnergy()', tips: 'clickEnergy' },
        { id: 59, describe: 'clickFlyer', img: process.env.IMG_BASE_URL + 'mars_clickFlyer.png', code: 'clickFlyer()', tips: 'clickFlyer' },
    ],
    // 图片管理
    allImageMap: {
        // onlineClass.vue
        'welcomeDialog_zh': process.env.IMG_BASE_URL + 'welcomeDialog_zh.png',
        'welcomeDialog_en': process.env.IMG_BASE_URL + 'welcomeDialog_en.png',
        'welcomeDialog_sp': process.env.IMG_BASE_URL + 'welcomeDialog_sp.png',
        'welcomeDialog_fr': process.env.IMG_BASE_URL + 'welcomeDialog_fr.png',
        'welcomeDialogConfirm': process.env.IMG_BASE_URL + 'welcomeDialogConfirm.png',
        'codeIndexDialog_zh': process.env.IMG_BASE_URL + 'codeIndexDialog_zh2.png',
        'codeIndexDialog_txt_zh': process.env.IMG_BASE_URL + 'codeIndexDialog_txt_zh1.png',
        'codeIndexDialog_en': process.env.IMG_BASE_URL + 'codeIndexDialog_en.png',
        'codeIndexDialog_txt_en': process.env.IMG_BASE_URL + 'codeIndexDialog_txt_en.png',
        'codeIndexDialog_sp': process.env.IMG_BASE_URL + 'codeIndexDialog_sp.png',
        'codeIndexDialog_txt_sp': process.env.IMG_BASE_URL + 'codeIndexDialog_txt_sp.png',
        'codeIndexDialog_fr': process.env.IMG_BASE_URL + 'codeIndexDialog_fr.png',
        'codeIndexDialog_txt_fr': process.env.IMG_BASE_URL + 'codeIndexDialog_txt_fr.png',
        'codeIndexDialogClose': process.env.IMG_BASE_URL + 'codeIndexDialogClose.png',
        'popWin_05': process.env.IMG_BASE_URL + 'popWin_05.png',
        'popWin_15': process.env.IMG_BASE_URL + 'popWin_15.png',
        'popWin_13': process.env.IMG_BASE_URL + 'popWin_13.png',
        'popWin_03': process.env.IMG_BASE_URL + 'popWin_03.png',
        'popWin_10': process.env.IMG_BASE_URL + 'popWin_10.png',
        'popWin_08': process.env.IMG_BASE_URL + 'popWin_08.png',
        'winChina_01': process.env.IMG_BASE_URL + 'newChina.png',
        'winChina_02': process.env.IMG_BASE_URL + 'winChina_02.png',
        "errorChina_01": process.env.IMG_BASE_URL + 'errorChina_01.png',
        "errorChina_02": process.env.IMG_BASE_URL + 'errorChina_02.png',
        "errorChina_03": process.env.IMG_BASE_URL + 'errorChina_03.png',
        "popWin_055": process.env.IMG_BASE_URL + 'popWin_055.png',
        "popWin_056": process.env.IMG_BASE_URL + 'popWin_056.png',
        "popWin_057": process.env.IMG_BASE_URL + 'popWin_057.png',
        "popWin_058": process.env.IMG_BASE_URL + 'popWin_058.png',
        "popWin_061": process.env.IMG_BASE_URL + 'popWin_061.png',
        "popWin_062": process.env.IMG_BASE_URL + 'popWin_062.png',
        "popWin_063": process.env.IMG_BASE_URL + 'popWin_063.png',
        "skip": process.env.IMG_BASE_URL + 'skip.png',

        "game_bg01": process.env.IMG_BASE_URL + 'game_bg01.png',
        "game_demo03": process.env.IMG_BASE_URL + 'game_demo03.png',

        "error_00": process.env.IMG_BASE_URL + 'error_00.png',
        "success_00": process.env.IMG_BASE_URL + 'success_00.png',
        "line_01": process.env.IMG_BASE_URL + 'line_01.png',
        "line_02": process.env.IMG_BASE_URL + 'line_02.png',
        "step_01": process.env.IMG_BASE_URL + 'step_01.png',
        "step_02": process.env.IMG_BASE_URL + 'step_02.png',

        'delVideo': process.env.IMG_BASE_URL + 'delVideo.png',
        'opleftArrow': process.env.IMG_BASE_URL + 'leftArrow.png',
        'oprightArrow': process.env.IMG_BASE_URL + 'rightArrow.png',
        'exitBrowser': process.env.IMG_BASE_URL + 'exitBrowser.png',
        'sessionOut01': process.env.IMG_BASE_URL + 'sessionOut01.png',
        'pause': process.env.IMG_BASE_URL + 'pause.png',
        'shadow_reload': process.env.IMG_BASE_URL + 'shadow_reload.png',
        'music': process.env.IMG_BASE_URL + 'music.png',
        'demoBg': process.env.IMG_BASE_URL + 'demoBg.png',

        // head.vue
        'gameMain_03_04': process.env.IMG_BASE_URL + 'gameMain_03_04.png',
        'gameMainhead': process.env.IMG_BASE_URL + 'gameMainhead.png',
        'gameMain_02_07': process.env.IMG_BASE_URL + 'gameMain_02_07.png',
        'gameMain_0901': process.env.IMG_BASE_URL + 'gameMain_0902.png',
        'gameMain_0601': process.env.IMG_BASE_URL + 'gameMain_0601.png',
        'codeIndexButton': process.env.IMG_BASE_URL + 'codeIndexButton.png',
        'level': process.env.IMG_BASE_URL + 'level.png',
        'gameMain01': process.env.IMG_BASE_URL + 'gameMain01.png',
        'gameMain02': process.env.IMG_BASE_URL + 'gameMain02.png',
        'gameMain03': process.env.IMG_BASE_URL + 'gameMain03.png',
        'gameMain04': process.env.IMG_BASE_URL + 'gameMain04.png',
        'gameMain05': process.env.IMG_BASE_URL + 'gameMain05.png',
        'shadow_head': process.env.IMG_BASE_URL + 'shadow_head.png',
        'shadow_back': process.env.IMG_BASE_URL + 'shadow_back.png',
        // idebox.vue
        '41_03': process.env.IMG_BASE_URL + '41_03.png',
        '41_05': process.env.IMG_BASE_URL + '41_05.png',
        'gameMain-di_0113': process.env.IMG_BASE_URL + 'gameMain-di_0113.png',
        'aceBottom': process.env.IMG_BASE_URL + 'aceBottom.jpg',
        'action_select_left': process.env.IMG_BASE_URL + 'action_select_left.png',
        'gameMain-di_018': process.env.IMG_BASE_URL + 'gameMain-di_018.png',
        'resetButtonActive': process.env.IMG_BASE_URL + 'resetButtonActive.png',
        'resetButtonPressed': process.env.IMG_BASE_URL + 'resetButtonPressed.png',
        'runButtonActive': process.env.IMG_BASE_URL + 'runButtonActive.png',
        'runButtonPressed': process.env.IMG_BASE_URL + 'runButtonPressed.png',
        'stop01': process.env.IMG_BASE_URL + 'stop01.png',
        'stop02': process.env.IMG_BASE_URL + 'stop02.png',
        'audio01': process.env.IMG_BASE_URL + 'audio01.png',
        'block_reset': process.env.IMG_BASE_URL + 'blockly/block_reset.png',
        'audio02': process.env.IMG_BASE_URL + 'audio02.png',
        'questionMark01': process.env.IMG_BASE_URL + 'questionMark01.png',
        'questionMark': process.env.IMG_BASE_URL + 'questionMark.png',
        // checkpoint
        'menu': process.env.IMG_BASE_URL + 'menu.png',
        "checkBg": process.env.IMG_BASE_URL + 'checkBg01.png',
        'choose': process.env.IMG_BASE_URL + 'choose01.png',
        'border01': process.env.IMG_BASE_URL + 'border01.png',
        'border03': process.env.IMG_BASE_URL + 'border03.png',
        'icon1': process.env.IMG_BASE_URL + 'icon1.png',
        'icon2': process.env.IMG_BASE_URL + 'icon1.png',
        'icon3': process.env.IMG_BASE_URL + 'icon2.png',
        'icon4': process.env.IMG_BASE_URL + 'icon2.png',
        'icon5': process.env.IMG_BASE_URL + 'icon2.png',
        'icon6': process.env.IMG_BASE_URL + 'icon2.png',
        'icon7': process.env.IMG_BASE_URL + 'icon3.png',
        'icon8': process.env.IMG_BASE_URL + 'icon3.png',
        'icon9': process.env.IMG_BASE_URL + 'icon5.png',
        'icon10': process.env.IMG_BASE_URL + 'icon5.png',
        'icon11': process.env.IMG_BASE_URL + 'icon5.png',
        'icon12': process.env.IMG_BASE_URL + 'icon4.png',
        'icon13': process.env.IMG_BASE_URL + 'icon4.png',
        'icon14': process.env.IMG_BASE_URL + 'icon10.png',
        'icon15': process.env.IMG_BASE_URL + 'icon10.png',
        'checked': process.env.IMG_BASE_URL + 'checked.png',
        'highStar': process.env.IMG_BASE_URL + 'highStar.png',
        'left': process.env.IMG_BASE_URL + 'left.png',
        'right': process.env.IMG_BASE_URL + 'right.png',
        'leftArrow': process.env.IMG_BASE_URL + 'leftArrow01.png',
        'rightArrow': process.env.IMG_BASE_URL + 'rightArrow01.png',
        'block': process.env.IMG_BASE_URL + 'block.png',
        'block2': process.env.IMG_BASE_URL + 'block2.png',
        'lock_block': process.env.IMG_BASE_URL + 'lockblock.png',
        'demo01': process.env.IMG_BASE_URL + 'demo01.png',

        'bg': process.env.IMG_BASE_URL + 'bg.jpg',
        'checkLang': process.env.IMG_BASE_URL + 'checkLang.png',
        'checkLang01': process.env.IMG_BASE_URL + 'checkLang01.png',
        'checkLangBg': process.env.IMG_BASE_URL + 'checkLangBg.png',
        'menuDio': process.env.IMG_BASE_URL + 'menuDio.png',
        'menuBorder': process.env.IMG_BASE_URL + 'menuBorder.png',
        'menuDel': process.env.IMG_BASE_URL + 'menuDel.png',
        'tobig': process.env.IMG_BASE_URL + 'tobig.png',

        "blocklyL": process.env.IMG_BASE_URL + 'blockly/blocklyL.png',
        "blocklyR": process.env.IMG_BASE_URL + 'blockly/blocklyR.png',
        "blocklyC": process.env.IMG_BASE_URL + 'blockly/blocklyC.png',
        "audio001": process.env.IMG_BASE_URL + 'blockly/audio01.png',
        "audio002": process.env.IMG_BASE_URL + 'blockly/audio02.png',
        "op01": process.env.IMG_BASE_URL + 'blockly/op01.png',
        "run01": process.env.IMG_BASE_URL + 'blockly/run01.png',
        "run02": process.env.IMG_BASE_URL + 'blockly/run02.png',

        "icode_video_play": process.env.IMG_BASE_URL + 'videoplay/icode-video-play.png',
        "ICODE_qq01": process.env.IMG_BASE_URL + 'videoplay/ICODE-qq01.jpg',
        "icode_stage_qrcode_border": process.env.IMG_BASE_URL + 'videoplay/icode-stage-qrcode-border.png',
        "icode_video_lock": process.env.IMG_BASE_URL + 'videoplay/icode-video-lock.png',
        "icode_video_lock_time": process.env.IMG_BASE_URL + 'videoplay/icode-video-lock-time.png',
        "ICODE_weixin01": process.env.IMG_BASE_URL + 'videoplay/ICODE-weixin01.jpg',
        "ICODE_VIDEO_CLOSE": process.env.IMG_BASE_URL + 'videoplay/ICODE_VIDEO_CLOSE.png',

        // one hour
        "icode_onhour_all_pass": process.env.IMG_BASE_URL + 'hour/icode_onhour_all_pass.png',
        "icode_onhour_continue_btn": process.env.IMG_BASE_URL + 'hour/icode_onhour_continue_btn.png',
        "icode_onhour_exit": process.env.IMG_BASE_URL + 'hour/icode_onhour_exit.png',
        "icode_onhour_exit_confirm": process.env.IMG_BASE_URL + 'hour/icode_onhour_exit_confirm.png',
        "icode_onhour_get_price": process.env.IMG_BASE_URL + 'hour/icode_onhour_get_price.png',
        "icode_onhour_not_complete":process.env.IMG_BASE_URL + 'hour/icode_onhour_not_complete.png',
        "icode_onhour_not_all_pass":process.env.IMG_BASE_URL + 'hour/icode_onhour_not_all_pass.png',
        "icode_onhour_not_all_pass_btn":process.env.IMG_BASE_URL + 'hour/icode_onhour_not_all_pass_btn.png',
        "icode_gate_win": process.env.IMG_BASE_URL + 'win/zh/win.png',
        "video_bg_img": process.env.IMG_BASE_URL + 'videobg.png',
    },
    allBgMap: [
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit01.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit02.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit03.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit04.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit05.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit06.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit07.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit08.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit09.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit10.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit11.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit12.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit13.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit14.png' },
        { 'checkponit01': process.env.IMG_BASE_URL + 'checkponit15.png' },

    ]
};



// WEBPACK FOOTER //
// ./src/store/state.js